import { useMemo } from "react"
// @ts-expect-error — qr-encoder.js is a vanilla JS module without type declarations
import { encodeQr } from "../../../../qr-encoder.js"

interface QrCodeSvgProps {
  value: string
  size?: number
  className?: string
}

export function QrCodeSvg({ value, size = 200, className }: QrCodeSvgProps) {
  const qr = useMemo(() => {
    if (!value) return null
    try {
      return encodeQr(value) as { size: number; modules: boolean[] }
    } catch {
      return null
    }
  }, [value])

  if (!qr) return null

  const margin = 4
  const totalModules = qr.size + margin * 2
  const cellSize = size / totalModules

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${totalModules} ${totalModules}`}
      className={className}
      role="img"
      aria-label={`QR code linking to ${value}`}
    >
      <rect width={totalModules} height={totalModules} fill="#fff" />
      {qr.modules.map((dark, i) => {
        if (!dark) return null
        const row = Math.floor(i / qr.size)
        const col = i % qr.size
        return (
          <rect
            key={i}
            x={col + margin}
            y={row + margin}
            width={1}
            height={1}
            fill="#000"
          />
        )
      })}
    </svg>
  )
}

export function downloadQrSvg(url: string, slug: string) {
  let qr: { size: number; modules: boolean[] }
  try {
    qr = encodeQr(url) as { size: number; modules: boolean[] }
  } catch {
    return
  }

  const cellSize = 8
  const margin = 4
  const totalPx = (qr.size + margin * 2) * cellSize
  const rects: string[] = []
  rects.push(`<rect width="${totalPx}" height="${totalPx}" fill="#fff"/>`)
  for (let row = 0; row < qr.size; row++) {
    for (let col = 0; col < qr.size; col++) {
      if (qr.modules[row * qr.size + col]) {
        rects.push(
          `<rect x="${(col + margin) * cellSize}" y="${(row + margin) * cellSize}" width="${cellSize}" height="${cellSize}" fill="#000"/>`
        )
      }
    }
  }
  // URL text below QR code
  const textY = totalPx + 20
  const svgHeight = totalPx + 32
  const svg = [
    `<?xml version="1.0" encoding="UTF-8"?>`,
    `<svg xmlns="http://www.w3.org/2000/svg" width="${totalPx}" height="${svgHeight}" viewBox="0 0 ${totalPx} ${svgHeight}">`,
    ...rects,
    `<text x="${totalPx / 2}" y="${textY}" text-anchor="middle" font-family="ui-sans-serif,system-ui,sans-serif" font-size="10" fill="#666">${url.replace(/&/g, "&amp;").replace(/</g, "&lt;")}</text>`,
    `</svg>`,
  ].join("\n")

  const blob = new Blob([svg], { type: "image/svg+xml" })
  const href = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = href
  a.download = `stayframe-qr-${slug || "guidebook"}.svg`
  a.click()
  URL.revokeObjectURL(href)
}
